import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';
import { SubscriptionSink } from '@approot/utilities';
import {
  LegService,
  ProductsConfigService,
  UserStorageService
} from '@approot/services';
import {
  AttributeBase,
  KeyBoolean,
  ResultPerLeg,
  UserPreferencesState,
  UserPreferencesStateKey
} from '@approot/models';

type Rows = 'spot' | 'forward' | 'forwardPoints' | 'volAtm' | 'vol';

@Component({
  selector: 'market-data-display',
  templateUrl: './market-data-display.component.html',
  styleUrls: ['./market-data-display.component.scss']
})
export class MarketDataDisplayComponent implements OnDestroy, OnInit {
  @Input() public pricedLeg: ResultPerLeg;
  @Input() public cross: string;
  @Input() public attributesAsFormControls: AttributeBase<any>[];
  private subsink = new SubscriptionSink();
  private pricingDisplaySettings: KeyBoolean = {};
  private availableResults: KeyBoolean = {};

  constructor(
    private legService: LegService,
    private productsConfigService: ProductsConfigService,
    private userStorageService: UserStorageService,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.subsink.sink = this.userStorageService
      .storeChangesObservable<UserPreferencesState>(UserPreferencesStateKey)
      .subscribe(prefs => {
        this.pricingDisplaySettings = prefs['PricingDisplayPrefs'];
        const display =
          this.productsConfigService.pricingResultsInfo.marketDataSpecifications
            .filter(s => !s.header)
            .some(s => {
              return this.pricingDisplaySettings[s.shortName] ?? true;
            });
        this.renderer.setStyle(
          this.elementRef.nativeElement as HTMLElement,
          'display',
          display ? null : 'none'
        );
      });
  }
  public ngOnInit(): void {
    this.productsConfigService.pricingResultsInfo.marketDataSpecifications.forEach(
      result => (this.availableResults[result.shortName] = true)
    );
  }

  public ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }

  public isRowEnabled(name: Rows): boolean {
    return (
      (this.pricingDisplaySettings[name] ?? true) && this.availableResults[name]
    );
  }

  public get marketDataExpanded() {
    return this.legService.marketDataExpanded;
  }
}
